<template>
  <div class="row child-component">
    <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">
      <div class="d-block row col-lg-8 mx-auto">
        <div class="fieldborder mb-n2">
          <b-form-group label="Is this a foreign vendor that needs to be paid by Wire?"
            class="timeonly-text">
            <b-form-radio-group style="margin-left:14px;" v-model="ProdExpVendor.IsPaidByWire" id="IsPaidByWire" name="IsPaidByWire">
              <b-form-radio value="YES">Yes</b-form-radio>
              <b-form-radio value="NO">No</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
        <div class="fieldborder mb-n2" v-if="ProdExpVendor.IsPaidByWire == 'NO'">
          <b-form-group label="Did the vendor indicate that they would like to be setup for ACH payments?"
            class="timeonly-text">
            <b-form-radio-group style="margin-left:14px;" v-model="ProdExpVendor.IsACHPayment" id="IsACHPayment" name="IsACHPayment">
              <b-form-radio value="YES">Yes</b-form-radio>
              <b-form-radio value="NO">No</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
        <div class="fieldborder mb-n2" v-if="ProdExpVendor.IsACHPayment == 'YES'">
          <b-form-group label="Did the vendor provide a bank letter, invoice, or voided check confirming their account information?"
            class="timeonly-text">
            <b-form-radio-group style="margin-left:14px;" v-model="ProdExpVendor.HasBankLetterInvoice" id="HasBankLetterInvoice" name="HasBankLetterInvoice">
              <b-form-radio value="YES">Yes</b-form-radio>
              <b-form-radio value="NO">No</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
        <div class="fieldborder" v-if="ProdExpVendor.IsACHPayment === 'NO'">
            <label>Please provide the vendor confirmation email that ACH is not an option</label>
            <vue-dropzone v-on:vdropzone-mounted="mountedVendorConfirmationEmailVueDropzone" :duplicateCheck="true" ref="VendorConfirmationEmailVueDropzone"
                id="VendorConfirmationEmailVueDropzone" :useCustomSlot="true" class="customdropzone" :include-styling="false"
                :options="dropzoneOptions" v-on:vdropzone-file-added="UploadedToDropzoneVendorConfirmationEmail"
                v-on:vdropzone-removed-file="RemovedFromDropzoneVendorConfirmationEmail">
                <div class="dropzone-custom-content">
                    <p class="Drag-and-drop-file-h">
                        <b-img :src="closeFilterIcon" style="
                    margin-top: -7px !important;
                    font-family: 'Open Sans';
                " />
                        Drag and drop file here or
                        <span class="draganddropspan"> browse </span>
                    </p>
                </div>
            </vue-dropzone>
            <div class="note-section mt-2">
                <p>Acceptable file types: {{ AllowedFileUploadTypes }}.</p>
            </div>
        </div>
        <div v-if="ProdExpVendor.IsPaidByWire == 'YES' || ProdExpVendor.HasBankLetterInvoice == 'YES'">
            <div class="fieldborder my-2">
                <p class="note-section mx-auto notes">The banking information attached will be validated by the master data team.</p>
            </div>
            <div class="fieldborder my-3">
                <label class="lblAttachment" style="line-height: normal;">Please attach the External Media ACH/WIRE Form. This form can be downloaded on the landing page</label>
                <vue-dropzone v-on:vdropzone-mounted="mountedCreditCardFilesVueDropzone" :duplicateCheck="true" ref="creditCardFilesVueDropzone"
                    id="creditCardFilesVueDropzone" :useCustomSlot="true" class="customdropzone" :include-styling="false"
                    :options="dropzoneOptions" v-on:vdropzone-file-added="UploadedToCreditCardFilesDropzone"
                    v-on:vdropzone-removed-file="RemovedFromCreditCardFilesDropzone">
                    <div class="dropzone-custom-content">
                        <p class="Drag-and-drop-file-h">
                            <b-img :src="closeFilterIcon" style="
                        margin-top: -7px !important;
                        font-family: 'Open Sans';
                    " />
                            Drag and drop file here or
                            <span class="draganddropspan"> browse </span>
                        </p>
                    </div>
                </vue-dropzone>
                <div class="note-section mt-2">
                    <p>Acceptable file types: {{ AllowedFileUploadTypes }}.</p>
                </div>
            </div>
            <div class="fieldborder pt-2">
              <label>Bank Name</label>
              <b-form-input @focus="ResetDirty('BankName')" @blur="SetDirty('BankName')" autocomplete="off"
                  id="bank-name" class="omniipclass" v-model="ProdExpVendor.BankName" placeholder="Enter Bank Name"
                  :maxlength="99">
              </b-form-input>
              <div class="error-message-format"
                  v-if="$v.ProdExpVendor.BankName.$dirty && !$v.ProdExpVendor.BankName.required">
                  Required field
              </div>
          </div>
          <div class="fieldborder pt-2">
              <label>BANK COUNTRY</label>
              <OmniSelect @focus="ResetDirty('BankCountry')" @blur="SetDirty('BankCountry')"
                  class="pt-0 mb-0 omniipclass omniindexclass" placeholder="Select Country" name="BankCountry"
                  :showLabel="false" label="BankCountry" v-model="ProdExpVendor.BankCountry" :options="CountryList">
              </OmniSelect>
              <div class="error-message-format"
                  v-if="$v.ProdExpVendor.BankCountry.$dirty && !$v.ProdExpVendor.BankCountry.required">
                  Required field
              </div>
          </div>
          <div class="fieldborder pt-2">
              <label>BANK ADDRESS LINE 1 </label>
              <b-form-input @focus="ResetDirty('BankAddressLine1')" @blur="SetDirty('BankAddressLine1')"
                  autocomplete="off" id="bankaddressline1" class="omniipclass"
                  v-model="ProdExpVendor.BankAddressLine1" placeholder="Enter Bank Address Line1"
                  :maxlength="26"></b-form-input>
              <div class="error-message-format"
                  v-if="$v.ProdExpVendor.BankAddressLine1.$dirty && !$v.ProdExpVendor.BankAddressLine1.required">
                  Required field
              </div>
          </div>
          <div class="fieldborder pt-2">
              <label>BANK ADDRESS LINE 2 </label>
              <b-form-input @focus="ResetDirty('BankAddressLine2')" @blur="SetDirty('BankAddressLine2')"
                  autocomplete="off" id="bankaddressline2" class="omniipclass"
                  v-model="ProdExpVendor.BankAddressLine2" placeholder="Enter Bank Address Line2"
                  :maxlength="26"></b-form-input>
          </div>
          <div class="fieldborder pt-2" v-if="IsCountryUSA">
              <label for="city" class="lbltxt">BANK CITY</label>
              <b-form-input @focus="ResetDirty('BankCity')" @blur="SetDirty('BankCity')" autocomplete="off"
                  id="billingCity" class="omniipclass" v-model="ProdExpVendor.BankCity"
                  placeholder="Enter City" :maxlength="19"></b-form-input>
              <div class="error-message-format"
                  v-if="$v.ProdExpVendor.BankCity.$dirty && !$v.ProdExpVendor.BankCity.required">
                  Required field
              </div>
          </div>
          <div class="row fieldborder pt-2" v-if="IsCountryUSA">
              <div class="col-md-8">
                  <label for="BankState" class="lbltxt">BANK State</label>
                  <OmniSelect @blur="SetDirty('BankState')" @focus="ResetDirty('BankState')"
                      class="pt-0 omniindexclass omniindexclass" placeholder="Select State"
                      name="BankState" :showLabel="false" :showSearch="true"
                      v-model="ProdExpVendor.BankState" :options="StateList">
                  </OmniSelect>
                  <div class="error-message-format"
                      v-if="$v.ProdExpVendor.BankState.$dirty && !$v.ProdExpVendor.BankState.required">
                      Required field
                  </div>
              </div>
              <div class="col-md-4">
                  <label v-if="IsCountryUSA" for="BankZipCode" class="lbltxt">ZIP CODE</label>

                  <b-form-input autocomplete="off" id="BankZipCode" class="" :minlength="5"
                  v-if="IsCountryUSA" :maxlength="5" v-bind:class="{
                          redtextbox: (validationtextbox || !$v.ProdExpVendor.BankZipCode.numeric) && $v.ProdExpVendor.BankZipCode.$dirty,
                          notredtextbox: !validationtextbox && $v.ProdExpVendor.BankZipCode.numeric,
                      }" @blur="SetDirty('BankZipCode')" @focus="ResetDirty('BankZipCode')"
                      @keyup="ValidateZipCode()" v-model="ProdExpVendor.BankZipCode"
                      placeholder="Enter Zip Code"></b-form-input>
                  <div v-show="validationtextbox && $v.ProdExpVendor.BankZipCode.$dirty" style="width:135px;"
                      class="error-message-format">
                      Input must be 5 characters
                  </div>
                  <div v-show="!$v.ProdExpVendor.BankZipCode.numeric && $v.ProdExpVendor.BankZipCode.$dirty"
                      style="width:135px;" class="error-message-format">
                      This field can only contain numerical values
                  </div>
              </div>
          </div>
          <div class="fieldborder pt-2">
            <label>Bank Account name</label>
            <b-form-input autocomplete="off" id="AccountName" class="omniipclass" v-model="ProdExpVendor.BankAccountName" placeholder="Enter Account name"></b-form-input>
          </div>
          <div class="fieldborder pt-2">
            <label>Bank Account number</label>
          <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['##', '#################']"
            style="margin-top:1px;" class="form-control" @focus="ResetDirty(ProdExpVendor.BankAccountNumber)"
            @blur="SetDirty(ProdExpVendor.BankAccountNumber)" placeholder="Enter Account Number" autocomplete="off" id="BankAccountNumber" v-model="ProdExpVendor.BankAccountNumber"></the-mask>
          </div>
          <div class="fieldborder pt-2" v-if="!IsCountryUSA">
            <label>SORT/SWIFT (NON US)</label>
          <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['##', '#########']"
            style="margin-top:1px;" class="form-control" @focus="ResetDirty(ProdExpVendor.BankSWIFTCode)"
            @blur="SetDirty(ProdExpVendor.BankSWIFTCode)" placeholder="Enter Sort/Swift (Non US)" autocomplete="off" id="BankSwiftCode" v-model="ProdExpVendor.BankSWIFTCode"></the-mask>
          </div>
          <div class="fieldborder pt-2" v-if="!IsCountryUSA">
            <label>IBAN (NON US)</label>
          <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['##', '#########']"
            style="margin-top:1px;" class="form-control" @focus="ResetDirty(ProdExpVendor.BankIBAN)"
            @blur="SetDirty(ProdExpVendor.BankIBAN)" placeholder="Enter IBAN (Non US)" autocomplete="off" id="IBAN" v-model="ProdExpVendor.BankIBAN"></the-mask>
          </div>
          <div class="fieldborder pt-2" v-if="IsCountryUSA">
            <label>Routing Number (US Only)</label>
          <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['##', '#########']"
            style="margin-top:1px;" class="form-control" @focus="ResetDirty(ProdExpVendor.BankRoutingNumber)"
            @blur="SetDirty(ProdExpVendor.BankRoutingNumber)" placeholder="Enter Routing Number (US Only)" autocomplete="off" id="BankRoutingNumber" v-model="ProdExpVendor.BankRoutingNumber"></the-mask>
          </div>
          <div class="fieldborder pt-2 position-relative">
            <label>Remittance Advice Email</label>
            <b-form-input autocomplete="off" id="entitynameperagreement" class="omniipclass"
              v-model="ProdExpVendor.RemittanceAdviceEmail" placeholder="Enter Remittance Advice Email"
              :maxlength="99"></b-form-input>
            <div class="error-message-format" v-if="!$v.ProdExpVendor.RemittanceAdviceEmail.email">
              Please enter a valid email address (eg. test@FinSys.com)
            </div>
          </div>
          <div class="fieldborder pt-2">
            <label for="axlocatoin" class="lbltxt">Please attach bank letter, invoice, or voided check.</label>
            <vue-dropzone v-on:vdropzone-mounted="mountedmyVueDropzone" :duplicateCheck="true" ref="myWireInfoSheetsVueDropzone" id="myWireInfoSheetsVueDropzone" :useCustomSlot="true"
              class="customdropzone" :include-styling="false" :options="dropzoneOptions"
              v-on:vdropzone-file-added="UploadedtoDropzone" v-on:vdropzone-removed-file="RemovedFromDropzone"
              v-modal="test">
              <div class="dropzone-custom-content">
                <p class="Drag-and-drop-file-h">
                  <b-img style="
                        margin-top: -7px !important;
                        font-family: 'Open Sans';
                      " />
                  Drag and drop file here or
                  <span class="draganddropspan"> browse </span>

                </p>
              </div>
            </vue-dropzone>
            <div class="note-section mt-2">
              <p>Acceptable file types: {{ AllowedFileUploadTypes }}.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="form-group pt-60 text-right  footer-buttons" style="padding-right:96px !important;">
      <button class="btn btn-link text-uppercase" @click="Cancel()">
        CANCEL
      </button>
      <button v-if="IsDraftVisible" class="text-uppercase btn btn-secondary btn-primary" @click="SaveAsDraft()">
          SAVE FOR LATER
      </button>
      <button class="text-uppercase btn custom-button btn-primary" @click="Previous()">
        BACK
      </button>
      <button class="text-uppercase btn custom-button btn-primary" @click="Next()" :disabled="this.$v.$invalid || this.BankLetterInvoiceNotSelected">
        NEXT
      </button>
    </div>
    <b-modal v-model="ShowPaymentInfo" hide-footer :no-close-on-backdrop="true">
        <div>
            <p v-if="ProdExpVendor.IsACHPayment === 'NO'">
                There is an Omnicom directive that ALL vendors must be set up to be paid by ACH. Unless the vendor expressly confirms that they cannot provide ACH, this information must be collected. Requests to set vendors up for check payment will be escalated to the controller's team for approval, and written documentation from the vendor confirming that they cannot provide ACH must be provided.
            </p>
            <p v-if="ProdExpVendor.HasBankLetterInvoice === 'NO'">
                You must obtain this information before proceeding with this request.
            </p>
        </div>
        <template v-slot:modal-header="{ close }">
            <h5 class="modal-title">Note</h5>
            <button class="close" @click="CancelPaymentInfo()"></button>
        </template>

        <div class="text-right">
            <button class="text-uppercase btn custom-button btn-primary" @click="CancelPaymentInfo()">
                Ok
            </button>
        </div>
    </b-modal>
  </div>
</template>


<style scoped>
.ACHcontent {
  height: 19px;
  margin: 6px 0 0;
  font-family: 'Open Sans' !important;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.58;
  letter-spacing: normal;
  color: #4d5161;
}

.error-message {
  padding-top: 10px;
  padding-bottom: 5px;
  height: 14px !important;
  font-size: 12px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #df5678 !important;
}

.floating-label-input {
  margin-top: 0px !important;
}

.omniipclass {
  /* width: 415px !important; */
  height: 35px !important;
  border: #e9eef0 !important;
  /* style="width:415px; height:35px;" */
}

.Text {
  width: 250px;
  height: 196px;
  font-family: "Open Sans";
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

.Text .text-style-1 {
  font-weight: 600;
}

.customdropzone {
  height: auto !important;
  border-radius: 8px !important;
  border: dashed 2px #e9eef0 !important;
  background-color: #ffffff !important;
  cursor: pointer !important;
}

.Drag-and-drop-file-h {
  margin-left: 18px !important;
  margin-top: 14px !important;
  width: 387px !important;
  height: 10px !important;
  font-family: "Open Sans" !important;
  font-size: 14px !important;
  font-weight: normal !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 0.71 !important;
  letter-spacing: normal !important;
  /* color: #a2a9ad !important; */
}

.draganddropspan {
  color: #00a1d2;
}
</style>

<script>
import { mapGetters } from "vuex";
import service from "../../../services/Dropdowns";
import { required, requiredIf, helpers,minLength ,numeric } from "vuelidate/lib/validators";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { TheMask } from 'vue-the-mask';
import store from "@/store";
import * as AllowedFileUploadExtensions from "../../../utilities/AllowedFileUploadExtensions";
const EmailRegEx = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[x01-x08x0bx0cx0e-x1fx21x23-x5bx5d-x7f]|[x01-x09x0bx0cx0e-x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[x01-x08x0bx0cx0e-x1fx21-x5ax53-x7f]|\\[x01-x09x0bx0cx0e-\x7f])+)\])$/
const EmailWithoutCase = helpers.regex('EmailWithoutCase', EmailRegEx);
import productionVendorSaveAsDraft from '../../../mixins/productionVendorSaveAsDraft.js';
export default {
  mixins: [productionVendorSaveAsDraft],
  validations: {
    ProdExpVendor: {
      IsPaidByWire: { required },
      IsACHPayment: {
        required: requiredIf(function (model) {
          return model.IsPaidByWire == "NO";
        }),
      },
      HasBankLetterInvoice: {
        required: requiredIf(function (model) {
          return model.IsACHPayment == "YES";
        }),
      },
      VendorConfirmationEmail: {
          minLength: minLength(1),
          required: requiredIf(function (model) {
              return model.IsACHPayment == "NO";
            })
      },
      RemittanceAdviceEmail: {
        required: requiredIf(function (model) {
          return model.HasBankLetterInvoice == "YES" || model.IsPaidByWire == "YES";
        }),
        email: EmailWithoutCase
      },
      CreditCardFiles: {
          minLength: minLength(1),
          required: requiredIf(function (model) {
            return model.HasBankLetterInvoice == "YES" || model.IsPaidByWire == "YES";
          })
      },
      WireInfoSheets: {
        minLength: minLength(1),
        required: requiredIf(function (model) {
          return model.HasBankLetterInvoice == "YES" || model.IsPaidByWire == "YES";
        })
      },
      BankAccountName: {
        required: requiredIf(function (model) {
          return model.HasBankLetterInvoice == "YES" || model.IsPaidByWire == "YES";
        })
      },
      BankAccountNumber: {
        required: requiredIf(function (model) {
          return model.HasBankLetterInvoice == "YES" || model.IsPaidByWire == "YES";
        }),
        numeric,
      },
      BankSWIFTCode: {
        required: requiredIf(function (model) {
          return (model.HasBankLetterInvoice == "YES" || model.IsPaidByWire == "YES") && model.BankCountry != this.CountryUnitedStatesValue;
        }),
        numeric,
      },
      BankIBAN: {
        required: requiredIf(function (model) {
          return (model.HasBankLetterInvoice == "YES" || model.IsPaidByWire == "YES") && model.BankCountry != this.CountryUnitedStatesValue;
        }),
        numeric,
      },
      BankRoutingNumber: {
        required: requiredIf(function (model) {
          return (model.HasBankLetterInvoice == "YES" || model.IsPaidByWire == "YES") && model.BankCountry == this.CountryUnitedStatesValue;
        }),
        numeric,
      },
      BankName: {
        required: requiredIf(function (model) {
          return model.HasBankLetterInvoice == "YES" || model.IsPaidByWire == "YES";
        })
      },
      BankCountry: {
        required: requiredIf(function () {
          return this.ProdExpVendor.HasBankLetterInvoice == "YES" || this.ProdExpVendor.IsPaidByWire == "YES";
        })
      },
      BankAddressLine1: {
        required: requiredIf(function () {
          return this.ProdExpVendor.HasBankLetterInvoice == "YES" || this.ProdExpVendor.IsPaidByWire == "YES";
        })
      },
      BankCity: {
          required: requiredIf(function (model) {
              return model.BankCountry == this.CountryUnitedStatesValue && (this.ProdExpVendor.HasBankLetterInvoice == "YES" || this.ProdExpVendor.IsPaidByWire == "YES");
          }),
      },
      BankState: {
          required: requiredIf(function (model) {
              return model.BankCountry == this.CountryUnitedStatesValue && (this.ProdExpVendor.HasBankLetterInvoice == "YES" || this.ProdExpVendor.IsPaidByWire == "YES");
          }),
      },
      BankZipCode: {
          required: requiredIf(function (model) {
              return model.BankCountry == this.CountryUnitedStatesValue && (this.ProdExpVendor.HasBankLetterInvoice == "YES" || this.ProdExpVendor.IsPaidByWire == "YES");
          }),
          numeric,
      },
    }
  },
  data() {
    return {
      FilesUploadedVendorConfirmationEmail: false,
      FilesUploadedWireInfoSheets: false,
      FilesUploadedCreditCardFiles: false,
      ShowPaymentInfo: false,
      CountryUnitedStatesValue: "USA - United States",
      ddl: 0,
      InterAgencyCountryList: [],
      FilesUploaded: false,
      AllowedFileUploadTypes: AllowedFileUploadExtensions.FileUploadExtensions.join(", "),
      dropzoneOptions: {
        closeFilterIcon: require("@/assets/Icons/add-client.svg"),
        previewTemplate: this.template(),
        url: `${process.env.VUE_APP_API_ROOT}api/v1/ProfileUnlock/test`,
        uploadMultiple: true,
        maxFiles: 5,
        minFiles: 1,
        maxFilesize: 10,
        addRemoveLinks: false,
        parallelUploads: 5,
        createImageThumbnails: false,
        autoProcessQueue: false,
        init: function () {
          this.on("addedfile", function (file) {
            if (this.files.length > 5) {
              this.removeFile(file);
              window.alert('Maximum File Upload limit is 5!');
            }
          });
        },
        accept: function(file, done) {
          let fileExtension = file.name.split('.').pop().toLowerCase();
          if (!AllowedFileUploadExtensions.FileUploadExtensions.includes(fileExtension)) {
            store.dispatch(
              "progress/setErrorMessage",
              `Unsupported file type. Please upload a valid file type.`
            );
            this.removeFile(file);
          } else {
            done();
          }
        },
      },
      CountryList: [],
      StateList: [],
      validationtextbox: false,
    }
  },
  components: {
    vueDropzone: vue2Dropzone, TheMask
  },
  props: {
        id: {
            type: Number,
            required: false,
        },
        isDraft: {
            type: Boolean,
            required: false
        }
  },
  mounted() {
      this.LoadDropdownValues();
  },
  computed: {
    BankLetterInvoiceNotSelected() {
        return this.ProdExpVendor.HasBankLetterInvoice === 'NO';
    },
    ...mapGetters('prodexpvendor', {
      ProdExpVendor: 'ProdExpVendor',
    }),
    IsEdit() {
      return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
    },
    IsCountryUSA() {
        return this.ProdExpVendor.BankCountry != null ?
            this.ProdExpVendor.BankCountry == this.CountryUnitedStatesValue :
            null;
    },
    IsDraftVisible() {
        return this.id == null || this.id == 0 || this.isDraft == true;
    }
  },
  methods: {
      mountedVendorConfirmationEmailVueDropzone() {
          if (this.ProdExpVendor.IsEditDataLoaded == true && this.IsEdit && this.FilesUploadedVendorConfirmationEmail == false) {
              this.ManuallyUploadVendorConfirmationEmail(this.ProdExpVendor.VendorConfirmationEmail);
              this.$set(this.ProdExpVendor, "VendorConfirmationEmail", this.GetFilesVendorConfirmationEmail());
          }
      },
      ManuallyUploadVendorConfirmationEmail(files) {
          if (this.$refs.VendorConfirmationEmailVueDropzone != null) {
              if (files != null && files.length > 0 && this.FilesUploadedVendorConfirmationEmail == false) {
                  files.forEach((fileUploaded) => {
                      let file = {
                          size: fileUploaded.Length,
                          name: fileUploaded.Name,
                          type: fileUploaded.Extension,
                      };
                      var url = fileUploaded.FullName;
                      this.$refs.VendorConfirmationEmailVueDropzone.manuallyAddFile(file, url);
                  });
              }
              this.FilesUploadedVendorConfirmationEmail = true;
          }
      },
      UploadedToDropzoneVendorConfirmationEmail() {
          this.$set(this.ProdExpVendor, "VendorConfirmationEmail", this.GetFilesVendorConfirmationEmail());
      },
      RemovedFromDropzoneVendorConfirmationEmail() {
          this.$set(this.ProdExpVendor, "VendorConfirmationEmail", this.GetFilesVendorConfirmationEmail());
      },
      GetFilesVendorConfirmationEmail() {
          let files = [];
          if (this.$refs.VendorConfirmationEmailVueDropzone.dropzone.files && this.$refs.VendorConfirmationEmailVueDropzone.dropzone.files.length > 0) {
              let filesExists = this.$refs.VendorConfirmationEmailVueDropzone.dropzone.files;
              for (let i = 0; i < filesExists.length; i++) {
                  files.push({
                      name: filesExists[i].name,
                      file: filesExists[i]
                  });
              }
              return files;
          } else {
              return files;
          }
      },
      CancelPaymentInfo() {
          this.ShowPaymentInfo = false;
      },
      ResetBankingInfo() {
          this.ProdExpVendor.BankName = '';
          this.ProdExpVendor.BankCountry = '';
          this.ProdExpVendor.BankAddressLine1 = '';
          this.ProdExpVendor.BankAddressLine2 = '';
          this.ProdExpVendor.BankCity = '';
          this.ProdExpVendor.BankState = '';
          this.ProdExpVendor.BankZipCode = '';
          this.ProdExpVendor.BankAccountName = '';
          this.ProdExpVendor.BankAccountNumber = '';
          this.ProdExpVendor.BankRoutingNumber = '';
          this.ProdExpVendor.BankSWIFTCode = '';
          this.ProdExpVendor.BankIBAN = '';
          this.ProdExpVendor.RemittanceAdviceEmail = '';
          this.ProdExpVendor.CreditCardFiles = [];
          this.ProdExpVendor.WireInfoSheets = [];

      },
      SetDirty(propertyName) {
          this.$v.ProdExpVendor[propertyName].$touch();

      },
      ResetDirty(propertyName) {
          this.$v.ProdExpVendor[propertyName].$reset();
      },
    Cancel() {
      this.$router.push("/VendorRequests");
    },
    template: function () {
      return `<div class="dz-preview dz-file-preview" style='background-color:#ffffff !important;display:flex;'>

                <div class="dz-details" style='margin-right:79px !important;'>
                    <div class="dz-size" style="display:none;" ><span data-dz-size></span></div>
                    <div class="FileforNewClientxls-Copy" style="margin-left:20px;width:280px;cursor:default !important;" ><span style='word-break:break-all !important;font-size:14px !important;font-weight:400;font-stretch:normal;font-style: normal;line-height: 0.71;color: #00a1d2 !important; font-family:"Open Sans" !important;' data-dz-name></span></div>
                </div>
                <a>
                 <img data-dz-remove=""  style='' src='/icons/fileremove.svg'  @click="DeleteServerFile()" ></img>
                </a>
            </div>`;
    },
    mountedmyVueDropzone() {
      if (this.ProdExpVendor.IsEditDataLoaded == true && this.IsEdit && this.FilesUploadedWireInfoSheets == false) {
          this.ManuallyUploadWireInfoSheetsFiles(this.ProdExpVendor.WireInfoSheets);
          this.$set(this.ProdExpVendor, "WireInfoSheets", this.GetFilesObject());
      }
    },
    mountedCreditCardFilesVueDropzone() {
      if (this.ProdExpVendor.IsEditDataLoaded == true && this.IsEdit && this.FilesUploadedCreditCardFiles == false) {
          this.ManuallyUploadFiles(this.ProdExpVendor.CreditCardFiles);
          this.$set(this.ProdExpVendor, "CreditCardFiles", this.GetCreditCardFilesObject());
      }
    },
    UploadedToCreditCardFilesDropzone() {
        this.$set(this.ProdExpVendor, "CreditCardFiles", this.GetCreditCardFilesObject());
    },
    RemovedFromCreditCardFilesDropzone() {
        this.$set(this.ProdExpVendor, "CreditCardFiles", this.GetCreditCardFilesObject());
    },
    GetCreditCardFilesObject() {
        let files = [];
        if (this.$refs.creditCardFilesVueDropzone.dropzone.files && this.$refs.creditCardFilesVueDropzone.dropzone.files.length > 0) {
            let filesExists = this.$refs.creditCardFilesVueDropzone.dropzone.files;
            for (let i = 0; i < filesExists.length; i++) {
                files.push({
                    name: filesExists[i].name,
                    file: filesExists[i]
                });
            }
            return files;
        } else {
            return files;
        }
    },
    UploadedtoDropzone() {
      this.$set(this.ProdExpVendor, "WireInfoSheets", this.GetFilesObject());
    },
    RemovedFromDropzone() {
      this.$set(this.ProdExpVendor, "WireInfoSheets", this.GetFilesObject());
    },
    ManuallyUploadFiles(files) {
      if (this.$refs.creditCardFilesVueDropzone != null) {
        if (files != null && files.length > 0 && this.FilesUploadedCreditCardFiles == false) {
          files.forEach((fileUploaded) => {
            let file = {
              size: fileUploaded.Length,
              name: fileUploaded.Name,
              type: fileUploaded.Extension,
            };
            var url = fileUploaded.FullName;
            this.$refs.creditCardFilesVueDropzone.manuallyAddFile(file, url);
          });
        }
        this.FilesUploadedCreditCardFiles = true;
      }
    },
    ManuallyUploadWireInfoSheetsFiles(files) {
      if (this.$refs.myWireInfoSheetsVueDropzone != null) {
        if (files != null && files.length > 0 && this.FilesUploadedWireInfoSheets == false) {
          files.forEach((fileUploaded) => {
            let file = {
              size: fileUploaded.Length,
              name: fileUploaded.Name,
              type: fileUploaded.Extension,
            };
            var url = fileUploaded.FullName;
            this.$refs.myWireInfoSheetsVueDropzone.manuallyAddFile(file, url);
          });
        }
        this.FilesUploadedWireInfoSheets = true;
      }
    },
    GetFilesObject() {
      let files = [];
      if (this.$refs.myWireInfoSheetsVueDropzone.dropzone.files && this.$refs.myWireInfoSheetsVueDropzone.dropzone.files.length > 0) {
        let filesExists = this.$refs.myWireInfoSheetsVueDropzone.dropzone.files;
        for (let i = 0; i < filesExists.length; i++) {
          files.push({
            name: filesExists[i].name, file: filesExists[i]
          });
        }
        return files;
      } else {
        return files;
      }
    },

    // UploadedtoDropzone() {
    //      this.ddl = this.$refs.myVueDropzone.dropzone.files.length;
    //     //this.$set(this.ProdExpVendor, "SetupInfo", this.GetFilesObject());
    // },
    // RemovedFromDropzone() {
    //   this.ddl = this.$refs.myVueDropzone.dropzone.files.length;
    //     //this.$set(this.ProdExpVendor, "SetupInfo", this.GetFilesObject());
    // },

    ValidateZipCode() {
        if (
            this.BankZipCode && this.BankZipCode.length != 0 &&
            this.BankZipCode.length <= 5
        ) {
            this.validationtextbox = true;
        } else {
            this.validationtextbox = false;
        }
    },
    LoadDropdownValues() {
        this.LoadStates();
        service
            .getEntityRecords("Markets")
            .then((res) => {
                if (res.data && res.data.length > 0) {
                    this.CountryList = res.data.sort((a, b) =>
                        a.label < b.label ? -1 : a.label > b.label ? 1 : 0
                    );
                    let indexUSA = this.CountryList.findIndex(
                        (i) => i.label == this.CountryUnitedStatesValue
                    );
                    let indexCanada = this.CountryList.findIndex(
                        (i) => i.label == "CAN - Canada"
                    );
                    if (indexCanada > -1)
                        this.CountryList.unshift(
                            this.CountryList.splice(indexCanada, 1)[0]
                        );
                    if (indexUSA > -1)
                        this.CountryList.unshift(this.CountryList.splice(indexUSA, 1)[0]);
                    this.CountryList.forEach(element => { element.value = element.label;});
                }
            })
            .catch((err) => {
                alert(err);
            });
    },
    async LoadStates() {
        service
            .getEntityRecords("States")
            .then((res) => {
                this.StateList = res.data;
                this.StateList.forEach(element => { element.value = element.label;});
            })
            .catch((err) => {
                alert(err);
            });
    },

    Next() {
      this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
      if (this.id) {
        if(this.ProdExpVendor.RequestType == 'production') {
            this.$router.push({
                name: "Production Expense Vendor Relationship",
                params: {
                    id: this.id,
                    isDraft: this.isDraft
                }
            });
        }
        else {
            this.$router.push({
                name: "Production Expense Vendor Services",
                params: {
                    id: this.id,
                    isDraft: this.isDraft
                }
            });
        }
    } else {
        if(this.ProdExpVendor.RequestType == 'production') {
            this.$router.push({
                name: "Production Expense Vendor Relationship"
            });
        }
        else{
            this.$router.push({
                name: "Production Expense Vendor Services"
            });
        }
    }
    },
    Previous() {
      if (this.id) {
        this.$router.push({
          name: "Production Expense Vendor Setup Info",
          params: {
            id: this.id,
            isDraft: this.isDraft
          }
        });
      } else {
        this.$router.push({
          name: "Production Expense Vendor Setup Info"
        });
      }
    },

    forminvalid() {
      if (this.ProdExpVendor.IsACHPayment == "YES") {
        if (this.ddl > 0) {
          return false;
        } else {
          return true;
        }
      }
      else {
        return false;
      }

    },

  },

  watch: {
    "ProdExpVendor.IsPaidByWire": function (val) {
      if (val == 'YES') {
        if(this.ProdExpVendor.IsACHPayment == 'YES') {
          this.ResetBankingInfo();
        }
        this.ProdExpVendor.IsACHPayment = null;
      }
      if (val == 'NO') {
        this.ResetBankingInfo();
      }
      if (val) {
          this.ProdExpVendor.HasBankLetterInvoice = null
      }
    },
    "ProdExpVendor.IsACHPayment": function (val) {
      if (val == 'NO') {
          this.ResetBankingInfo();
          this.ShowPaymentInfo = true;
      }
      if(val) {
          this.ProdExpVendor.HasBankLetterInvoice = null
      }
    },
    "ProdExpVendor.HasBankLetterInvoice": function (val) {
      if (val == 'NO') {
          this.ResetBankingInfo();
          this.ShowPaymentInfo = true;
      }
    },
    "ProdExpVendor.IsEditDataLoaded": function (val) {
      if (this.IsEdit == true && val == true) {
        this.ManuallyUploadWireInfoSheetsFiles(this.ProdExpVendor.WireInfoSheets);
      }
    },
    "ProdExpVendor.BankCountry": function (val) {
      if (val === 'USA - United States') {
        this.ProdExpVendor.BankIBAN = '';
        this.ProdExpVendor.BankSWIFTCode = '';
      } else {
        this.ProdExpVendor.BankCity = '';
        this.ProdExpVendor.BankState = '';
        this.ProdExpVendor.BankZipCode = '';
        this.ProdExpVendor.BankRoutingNumber = '';
      }
    },
  },
  activated() {
    this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
  },
}
</script>